import React from "react";
import Img from "./Img";
import className from "classnames";

export default function Card({
  vertical,
  horizontal,
  small,
  title,
  date,
  discription,
  imageSrc,
  alt,
  ...rest
}) {
  const classes = className("", {
    "flex flex-col justify-start items-center w-[300px] md:w-[448px] lg:w-[548px] h-[365px] md:h-[465px] text-start text-clip bgred-500":
      vertical && !small,
    // "bg-white w-fit h-[287px] rounded-[8px] pb-[10px]":vertical && small,
    // "bg-white flex flex-col justify-center items-center w-[90px] sm:w-[266px] md:w-[300px] lg:w-[366px] xl:w-[366px] text-clip rounded-[8px]":vertical && small,
    "bg-white flex flex-col justify-center items-center text-clip rounded-[8px]":
      vertical && small,
    "flex flex-row justify-start items-center bg-[#F5F5F5] w-[350px] md:w-[450px] lg:w-[548px] h-[105px] md:h-[145px] text-start rounded-[8px] overflow-hidden":
      horizontal,
  });

  return (
    <div className={classes}>
      <div className={horizontal ? "h-full shrink-0" : "w-full"}>
        <Img src={imageSrc} alt={alt} {...rest} />
      </div>
      <div
        className={
          horizontal
            ? "flex h-full min-w-0 flex-1 flex-col justify-center px-2 py-1 text-start md:px-3"
            : "h-20 w-full p-[5px] md:h-fit md:p-[10px]"
        }
      >
        <div className="line-clamp-3 w-full font-tajawal-regular text-sm font-bold md:text-base">
          {title}
        </div>
        <div className="shrink-0 pt-[3px] font-tajawal-regular text-xs font-light md:text-sm">
          {date}
        </div>
        {discription ? (
          <div className="line-clamp-3 text-start font-tajawal-regular font-medium">
            {discription}
          </div>
        ) : null}
      </div>
    </div>
  );
}
